import _defineProperty from "@babel/runtime/helpers/defineProperty";
var skinToneVariations = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 'raised hand', 'default skin tone'), 'raised hand: light skin tone', 'light skin tone'), 'raised hand: medium-light skin tone', 'medium-light skin tone'), 'raised hand: medium skin tone', 'medium skin tone'), 'raised hand: medium-dark skin tone', 'medium-dark skin tone'), 'raised hand: dark skin tone', 'dark skin tone');
export var setSkinToneAriaLabelText = function setSkinToneAriaLabelText(tone) {
  if (tone) {
    return skinToneVariations[tone];
  }
  return undefined;
};